// Tested indirectly via tests for the consuming code.
async function fetchJson(url, options) {
    const response = await fetch(url, options)

    if (response.status !== 200) {
        const data = await response.text()
        const err = new Error(`Request failed with status ${response.status}`)
        err.response = { status: response.status, data }
        throw err
    }

    return response.json()
}

module.exports = { fetchJson }
